import React from 'react';
import categoryIcon from 'images/downloads-category-icon.svg';
import { STIcon } from 'components/Brand/Icons/STIcon';

import { HeroContainer } from './styles';

const DownloadDetailHero = ({
  backgroundImg,
  downloadableContentType,
  title,
  industry,
  state,
  author,
  authors,
}) => {
  const isAuthorRequired = authors.some(
    (name) => name.firstName === author?.firstName && name.lastName === author?.lastName,
  );
  const authorUrl = isAuthorRequired
    ? `/author/${[author?.firstName, author?.lastName].filter(Boolean).join('-').toLowerCase()}`
    : null;

  return (
    <HeroContainer backgroundImg={backgroundImg}>
      <div className="download-detail-hero--wrapper">
        <p className="download-detail-hero--sub-title font-overline">{`${downloadableContentType} Guides`}</p>
        <h1 className="download-detail-hero--title font-h2">{title}</h1>
        <div className="flex align-center justify-center mt-[30px] gap-[40px]">
          <p className="download-detail-hero--category">
            <img
              className="download-detail-hero--category-icon"
              src={categoryIcon}
              alt="category-icon"
            />
            {`${industry ? `${industry.join(', ')}${state ? ', ' : ''}` : ''}${state || ''}`}
          </p>
          <p className="download-detail-hero--category">
            {authorUrl ? (
              <span>
                <a className="text-current" href={authorUrl}>
                  <STIcon type="user" alt="User Icon" style={{ margin: '0px 8px 0px 0px' }} />
                  {author?.firstName} {author?.lastName}
                </a>
              </span>
            ) : author ? (
              <span>
                <STIcon type="user" alt="User Icon" style={{ margin: '0px 8px 0px 0px' }} />
                {author?.firstName} {author?.lastName}
              </span>
            ) : null}
          </p>
        </div>
      </div>
    </HeroContainer>
  );
};

export default DownloadDetailHero;
